import React from 'react';
import { useEffect, useState } from 'react';
import './InspectionEdit.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Button as Button2,
  Typography,
} from '@material-ui/core';
import { format } from 'indian-number-format';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Button,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  CardText,
} from 'reactstrap';
import './AccessControls.css';
import passwordGenerator from 'generate-password';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import axios from '../axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import logoqa from '../assets/img/others/nodata.png';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  Divider,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Chip,
  Paper,
  TextField,
  Box,
  Popover,
  IconButton,
  InputAdornment,
  Checkbox,
  Zoom,
} from '@mui/material';
import {
  Table as Table2,
  TableBody as TableBody2,
  TableCell as TableCell2,
  TableContainer as TableContainer2,
  TableHead as TableHead2,
  TableRow as TableRow2,
} from '@mui/material';
// import { toast } from 'react-toastify';

import toastr from "toastr"
import "toastr/build/toastr.min.css";

function CustomerAccessControls() {
  const theme = useTheme();
  const matchesSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [customersData, setCustomersData] = useState([]);
  const [companyAccessData, setCompanyAccessData] = useState({});
  const [customerAccessDataTemp, setCustomerAccessDataTemp] = useState({});
  const [customerUser, setCustomerUser] = useState([])
  const [customersAccessData, setCustomersAccessData] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [editCustomersAccessData, setEditCustomersAccessData] = useState([]);
  const [customerAccData, setCustomerAccData] = useState({
    enable_mis: false,
    enable_po: false,
    enable_approval: false,
    enable_branch: false,
    enable_inventory: false,
    tomsWinAccess: false,
    imageAccess: false,
    modifyby: sessionStorage.getItem('Userid'),
  });

  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [bulkMailMode, setBulkMailMode] = useState(false);

  const [duplicateerror, setduplicateerror] = useState(false);
  //sweetalert
  const [added, setadded] = useState(false);
  const [deletedconfirm, setdeletedconfirm] = useState(false);
  const [deleted, setdeleted] = useState(false);
  const [updated, setupdated] = useState(false);
  const [deleteid, setdeleteid] = useState('');
  const [editId, setEditid] = useState('');
  const [CustomerID, setCustomerID] = useState('');
  const [mailSent, setMailSent] = useState(false);
  const [notWorking, setnotWorking] = useState(false);
  //tabledata
  const [tabledata, settabledata] = useState(customersAccessData);
  const [limitReached, setLimitReached] = useState(false);
  const [modal10, setModal10] = useState(false);
  const [openControls, setopenControls] = useState(false);
  const [openAddEmail, setOpenAddEmail] = useState(false);
  const [openRequestEmail, setOpenRequestEmail] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [emailHelperText, setEmailHelperText] = useState('');
  const [InputValue, setInputValue] = useState('');
  const [searchval, setsearchval] = useState(false);
  const [filteredAccess, setfilteredAccess] = useState([...customersData]);
  const [selectedCustomers1, setSelectedCustomers1] = useState({});
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const [createBalance, setcreateBalance] = useState(0);
  const [branchbalance, setBranchbalance] = useState(0);
  const [inventoryBalance, setInventoryBalance] = useState(0);
  const [ApprovalBalance, setApprovalBalance] = useState(0);

  const [noOfPoRequested, setNoOfPoRequested] = useState('');
  const [noOfApprovalRequested, setNoOfApprovalRequested] = useState('');
  const [noOfBranchRequested, setNoOfBranchRequested] = useState('');
  const [noOfInventoryRequested, setNoOfInventoryRequested] = useState('');
  const [error, setError] = useState('');
  const [mailSentRequest, setmailSentRequest] = useState(false);
  const [SelectedAccessIds, setSelectedAccessIds] = useState({})
  const [customerAccess, setcustomerAccess] = useState("")
  const[TompgFlag,setTompgFlag]=useState(false)

  const [Accessedcus,SetAccessedcus]=useState('')

  useEffect(() => {
    GetAllCustomerAccess();
    GetALLCustomerList();
    GetOneCompanyAccess();
    GetAllCustomerUser();
    GetOneVendorHelp()
    GetAccessedCus()
  }, []);

  const GetOneVendorHelp = async () => {
    const token = sessionStorage.getItem('AuthToken');
    const get = await axios.instance
      .get(`/GetOneVendordata/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: token, "Content-Type": "application/json" },
      })
      .then(res => {
        if (res.data.length > 0) {
          for (const data of res.data) {
            setTompgFlag(data.enable_tompg === "N" ? false : true)
            setcustomerAccess(data.no_of_Customer_Acc)
            // seteditflag(true)
          }
          


        } else {
          // setActive1(false)
          setcustomerAccess("")

        }
      })

  }

  const GetAccessedCus = async () => {
    const token = sessionStorage.getItem('AuthToken');
    const get = await axios.instance
      .get(`/GetAccessedCustomer/${sessionStorage.getItem('Companyid')}`, {
        headers: { Authorization: token, "Content-Type": "application/json" },
      })
      .then(res => {
        if (res.data.length > 0) {
          for (const data of res.data) {
            // setTompgFlag(data.enable_tompg === "N" ? false : true)
            SetAccessedcus(data.AccessedCustomer)
            // seteditflag(true)
          }
          


        } else {
          // setActive1(false)
          setcustomerAccess("")

        }
      })

  }

  const GetAllCustomerUser = async () => {
    const token = sessionStorage.getItem('AuthToken');
    setOpenLoader(true);
    await axios.instance
      .get("/GetAllCustomerUser", {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        const data = res.data;
        setCustomerUser(data);
        setOpenLoader(false);
      });
  }

  const isAvailable = (customer_id, EmailId) => {
    if (customerUser.length !== 0) {
      return Array.isArray(customerUser) &&
        customerUser.some(user => user.Customer_Log === customer_id && user.Emailid === EmailId);

    }
    else {
      return true;
    }
  }

  const GetAllCustomerAccess = async () => {
    const token = sessionStorage.getItem('AuthToken');
    setOpenLoader(true);
    await axios.instance
      .get(`GetAllCustomerAccess/${sessionStorage.getItem('Companyid')}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        const data = res.data;
        console.log(res.data, 'hanok');
        setCustomersAccessData(data);
        settabledata(res.data, 'tabledata');
        setOpenLoader(false);
      });
  };

  const GetALLCustomerList = async () => {
    setOpenLoader(true);
    const token = sessionStorage.getItem('AuthToken');
    await axios.instance
      .get(`GetALLCustomerList/${sessionStorage.getItem('Companyid')}/27`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        const data = res.data;
        const filterdata = data.filter(
          d =>
            (d.CustomerHO === 'Y' && d.CustomerHo_id == 0) ||
            (d.CustomerHO === 'N' && d.CustomerHo_id == 0),
        );

        console.log(filterdata, data);

        setCustomersData(filterdata);
        setOpenLoader(false);
      });
  };

  const GetOneCustomerAccess = id => {
    GetOneCompanyAccess();
    setOpenLoader(true);
    const token = sessionStorage.getItem('AuthToken');
    axios.instance
      .get(`GetOneCustomerAccess/${id}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        const data = res.data[0];
        // Transform the data
        const transformedData = {
          enable_mis: data.enable_mis === 'Y',
          enable_po: data.enable_po === 'Y',
          enable_approval: data.enable_approval === 'Y',
          enable_branch: data.enable_branch === 'Y',
          enable_inventory: data.enable_inventory === 'Y',
          tomsWinAccess: data.tomsWinAccess === 'Y',
          imageAccess: data.ImageAccess === 'Y',
          modifyby: sessionStorage.getItem('Userid'),
        };
        console.log(
          'Access Data:',
          transformedData,
          'inventoryBalance',
          inventoryBalance,
        );
        // Update the state
        setCustomerAccData(transformedData);
        setCustomerAccessDataTemp(transformedData);
        setEditCustomersAccessData(data);
        setEditid(data.cusaccessid);
        OpenDialogControls();
        setOpenLoader(false);
      })
      .catch(error => {
        console.error('Error fetching customer access:', error);
        setOpenLoader(false);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const GetOneCompanyAccess = () => {
    setOpenLoader(true);
    const token = sessionStorage.getItem('AuthToken');
    axios.instance
      .get(`GetOneCompanyAccess/${sessionStorage.getItem('Companyid')}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        setCompanyAccessData(res.data[0]);
        setLimitReached(
          res.data[0].no_of_po_acc <= res.data[0].enable_po_count,
        );
        balanceDataCheck(res.data[0]);
        setOpenLoader(false);
      })
      .catch(error => {
        console.error('Error fetching customer access:', error);
        setOpenLoader(false);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const balanceDataCheck = data => {
    setcreateBalance(
      data.no_of_po_acc === 'N' ? 0 : data.no_of_po_acc - data.enable_po_count,
    );
    setApprovalBalance(
      data.no_of_approve_acc === 'N'
        ? 0
        : data.no_of_approve_acc - data.enable_approval_count,
    );
    setInventoryBalance(
      data.no_of_inv_acc === 'N'
        ? 0
        : data.no_of_inv_acc - data.enable_inventory_count,
    );
    setBranchbalance(
      data.no_of_branch_acc === 'N'
        ? 0
        : data.no_of_branch_acc - data.enable_branch_count,
    );
  };

  const transformDataForAPI = data => {
    return {
      ...data,
      enable_mis: 'Y',
      // data.enable_mis ? 'Y' : 'N',
      enable_po: 'Y',
      // data.enable_po ? 'Y' : 'N',
      enable_approval: 'Y',
      // data.enable_approval ? 'Y' : 'N',
      enable_branch: 'Y',
      // data.enable_branch ? 'Y' : 'N',
      enable_inventory: 'Y',
      // data.enable_inventory ? 'Y' : 'N',
      tomsWinAccess: data.tomsWinAccess ? 'Y' : 'N',
      imageAccess: data.imageAccess ? 'Y' : 'N',
    };
  };

  const handleAddEmail = async () => {
    if (!newEmail) {
      setEmailError(true);
      setEmailHelperText('Email is required');
      return;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(newEmail)) {
      setEmailError(true);
      setEmailHelperText('Invalid email format');
      return;
    }

    setEmailError(false);
    setEmailHelperText('');
    setOpenLoader(true);
    try {
      await axios.instance.put(
        `AddMissingEmailtoCustomer/${CustomerID}/${newEmail}`,
      );
      GetAllCustomerAccess();
      GetAllCustomerUser();
      CloseAddEmailControl();
      setupdated(true);
      setOpenLoader(false);
      setNewEmail('');
      setCustomerID('');
    } catch (error) {
      console.error('Failed to add email', error);
    } finally {
      setOpenLoader(false);
      setNewEmail('');
    }
  };

  const CustomerAccessUpdate = async (id) => {
    // console.log(customerAccessDataTemp.enable_mis,"fdf")
    console.log(id);
    setOpenLoader(true);
    const transformedData = transformDataForAPI(customerAccData);
    console.log(transformedData, 'alldata');
    await axios.instance
      .put(`CustomerAccessUpdate/${id}`, transformedData)
      .then(res => {
        console.log(res.data);
        // setCusregdata(res.data)
        InsertCusregisterData(res.data[0]);
        GetOneCompanyAccess();
        setupdated(true);
        GetAllCustomerAccess();
        CloseDialogControls();
        setOpenLoader(false);
      });
  };

  const InsertCusregisterData = async data => {
    console.log('InsertCusregisterData', data);
    console.log(data);
    const userName =
      data.Contact_Person.length === 0 ? 'Admin' : data.Contact_Person;

    await axios.instance
      .post(`InsertCusUserRegData`, {
        User_Code: data.EmailId,
        Password: data.CusAccPassWord,
        Customer_Log: data.customer_id,
        AdminUser: 'Y',
        Department: 'Purchase',
        Designation: 'Purchase Manager',
        User_Name: userName,
        CustomerHo_Name: data.CustomerHO == 'Y' ? data.Customer_Name : '',
        CustomerHo_Id: data.CustomerHO == 'Y' ? data.customer_id : 0,
        Emailid: data.EmailId,
      })
      .then(res => {
        console.log(res.data);
      });
  };

  const generateRandomPassword = () => {
    const password = passwordGenerator.generate({
      length: 10, // length of the password
      numbers: true, // include numbers
      symbols: false, // include symbols
      uppercase: true, // include uppercase letters
      lowercase: true, // include lowercase letters
      excludeSimilarCharacters: true, // exclude similar characters like 'i' and 'l'
    });
    return password;
  };

  // setTimeout(() => {
  //   console.log('generateRandomPassword', generateRandomPassword());
  // }, 3000);

  const [customerenrolleddata, setcustomerenrolleddata] = useState([]);

  const handleGeneratePassword = () => {
    const newPassword = generateRandomPassword();
    console.log(newPassword);
    return newPassword;
  };

  const InsertNewCustomerAccess = async id => {
    console.log('InsertNewCustomerAccess', id);
    setOpenLoader(true);
    await axios.instance
      .post(`CustomerAccessInsert`, {
        companyaccessid: id[1],
        customer_id: id[0],
        CusAccPassWord: handleGeneratePassword(),
        Created_By: sessionStorage.getItem('Userid'),
        Created_Date: new Date(),
      })
      .then(res => {
        console.log(res.data);
        GetAllCustomerAccess();
        for (const data of res.data){
        CustomerAccessUpdate(data.cusaccessid)
        console.log(data.cusaccessid,'cusaccessid');
        }
        setOpenLoader(false);
      });
  };

  const CustomerAccessDelete = async id => {
    console.log('CustomerAccessDelete', id);
    setOpenLoader(true);
    await axios.instance.delete(`CustomerAccessDelete/${id}`).then(res => {
      setdeleted(true);
      GetAllCustomerAccess();
      setdeleteid('');
      console.log(id);
      setOpenLoader(false);
    });
  };

  const deleteCusregisterData = async id => {
    console.log('deleteCusregisterData', id);
    const deleteid = id.EmailId;
    setOpenLoader(true);
    await axios.instance
      .delete(`DeleteCusUserRegData/${deleteid}`)
      .then(res => {
        setOpenLoader(false);
      });
  };

  const [emailErr, setEmailErr] = useState(false);

  const validateEmail = email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSendMail = (customer_id, email) => {
    if (validateEmail(email)) {
      setEmailErr(false);
      mailForCredentials(customer_id);
    } else {
      setEmailErr(true);
    }
  };

  const mailForCredentials = async cusID => {
    setOpenLoader(true);
    await axios.instance
      .post(`mailForCredentials/${sessionStorage.getItem('Companyid')}/${cusID}`)
      .then(res => {
        console.log(res.data);
        if (res.data === 'Email sent successfully') {
          setMailSent(true);
        } else {
          setnotWorking(true);
        }
        GetAllCustomerAccess();
        setOpenLoader(false);
      });
  };

  const toggle10 = () => {
    if (modal10) {
      setModal10(false);
    } else {
      setModal10(true);
    }
    setInputValue('');
    GetALLCustomerList();
    GetAllCustomerAccess();
    setsearchval(false);
  };

  const OpenDialogControls = () => {
    setopenControls(true);
  };

  const CloseDialogControls = () => {
    setopenControls(false);
    setLimitReached(false);
  };

  const OpenAddEmailControl = () => {
    setOpenAddEmail(true);
  };

  const CloseAddEmailControl = () => {
    setOpenAddEmail(false);
  };

  const OpenReqEmailControl = () => {
    setOpenRequestEmail(true);
    CloseDialogControls();
  };

  const CloseReqEmailControl = () => {
    setOpenRequestEmail(false);
  };

  // const handleCheckboxChange = field => {
  //   setCustomerAccData(prevState => ({
  //     ...prevState,
  //     [field]: !prevState[field],
  //   }));
  // };

  const pages = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
    600, 700, 800, 900, 1000,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);

  const changepage = () => {
    return filteredData.slice(page * rowsperpage, (page + 1) * rowsperpage);
  };

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
  };

  const [selectedFilters, setSelectedFilters] = useState({
    enable_mis: false,
    enable_po: false,
    enable_approval: false,
    enable_branch: false,
    enable_inventory: false,
  });

  const handleBulkMailToggle = () => {
    setBulkMailMode(!bulkMailMode);
    setSelectedCustomers([]);
    GetALLCustomerList();
    GetAllCustomerAccess();
  };

  const handleCustomerCheckboxChange = (customerId, checked) => {
    if (checked) {
      setSelectedCustomers([...selectedCustomers, customerId]);
    } else {
      setSelectedCustomers(selectedCustomers.filter(id => id !== customerId));
    }
  };

  const handleSendBulkMail = async () => {
    setOpenLoader(true);
    try {
      for (const cusID of selectedCustomers) {
        await axios.instance.post(
          `mailForCredentials/${sessionStorage.getItem('Companyid')}/${cusID}`,
        );
      }
      setMailSent(true);
      setBulkMailMode(false);
      setSelectedCustomers([]);
      setOpenLoader(false);
      GetAllCustomerAccess();
    } catch (error) {
      console.error('Error sending bulk mail:', error);
      setnotWorking(true);
      setOpenLoader(false);
    }
  };

  // Handle checkbox change event
  // const handleCheckboxChange1 = (customerId,customeraccessid) => {
  //   setSelectedCustomers1(prevSelected => {
  //     const newSelected = {
  //       ...prevSelected,
  //       [customerId]: !prevSelected[customerId],
  //     };

  //     // Update the selected customer IDs array
  //     const newSelectedIds = Object.keys(newSelected)
  //       .filter(id => newSelected[id])
  //       .map(id => parseInt(id));

  //     setSelectedCustomerIds(newSelectedIds);
  //     console.log(newSelectedIds, 'ids');

  //     return newSelected;
  //   });
  // };

  const handleCheckboxChange1 = (customerId, customeraccessid) => {
    setSelectedCustomers1(prevSelected => {
      const newSelected = { ...prevSelected };

      if (newSelected[customerId]) {
        delete newSelected[customerId];
      } else {
        newSelected[customerId] = customeraccessid;
      }

      // Convert to array of [customerId, accessId]
      const selectedPairs = Object.entries(newSelected).map(
        ([id, accessId]) => [parseInt(id), accessId]
      );

      setSelectedCustomerIds(selectedPairs); // This is your final result
      console.log('Selected pairs:', selectedPairs);

      return newSelected;
    });
  };



  const handleCheckboxChange = field => {
    let updatedData = { ...customerAccData, [field]: !customerAccData[field] };

    if (field === 'enable_mis' && !updatedData.enable_mis) {
      updatedData = {
        ...updatedData,
        enable_po: false,
        enable_approval: false,
        enable_branch: false,
        enable_inventory: false,
      };
    }

    if (field === 'enable_po' && !updatedData.enable_po) {
      updatedData = {
        ...updatedData,
        enable_approval: false,
        enable_branch: false,
      };
    }

    if (field === 'enable_approval' && !updatedData.enable_approval) {
      updatedData.enable_branch = false;
    }

    setCustomerAccData(updatedData);
  };

  // Function to handle multiple customer insertion
  const handleInsertSelectedCustomers = async () => {
    for (const id of selectedCustomerIds) {
      await InsertNewCustomerAccess(id);
    }
    setSelectedCustomers1({});
    setSelectedCustomerIds([]);
    toggle10();
    setsearchval(false);
  };

  const handleChange3 = e => {
    const searchValue = e.target.value;
    setInputValue(searchValue);
    setsearchval(true);

    const filteredCusAceess = customersData.filter(po => {
      const searchValueLower = searchValue.toLowerCase();
      return (
        po.Customer_Name.toLowerCase().includes(searchValueLower) ||
        po.Contact_Person.toLowerCase().includes(searchValueLower) ||
        po.EmailId.toLowerCase().includes(searchValueLower)
      );
    });

    setfilteredAccess(filteredCusAceess);
  };

  const filteredData = customersAccessData.filter(data => {
    const matchesFilters = Object.keys(selectedFilters).every(filter => {
      return !selectedFilters[filter] || data[filter] === 'Y';
    });

    const matchesSearchQuery = data.Customer_Name.toLowerCase().includes(
      searchQuery.toLowerCase(),
    );

    return matchesFilters && matchesSearchQuery;
  });

  const handleFilterChange = filter => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filter]: !prevFilters[filter],
    }));
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const validateInputs = () => {
    const po = parseInt(noOfPoRequested, 10);
    const approval = parseInt(noOfApprovalRequested, 10);
    const branch = parseInt(noOfBranchRequested, 10);
    const inventory = parseInt(noOfInventoryRequested, 10);

    if (
      isNaN(po) ||
      po < 0 ||
      isNaN(approval) ||
      approval < 0 ||
      isNaN(branch) ||
      branch < 0 ||
      isNaN(inventory) ||
      inventory < 0
    ) {
      setError('All values must be 0 or above and not empty');
      setTimeout(() => {
        setError();
      }, 3000);
      return false;
    }

    setError('');
    return true;
  };

  const handleRequest = () => {
    if (validateInputs()) {
      const requestData = {
        noOfPoRequested: parseInt(noOfPoRequested, 10),
        noOfApprovalRequested: parseInt(noOfApprovalRequested, 10),
        noOfBranchRequested: parseInt(noOfBranchRequested, 10),
        noOfInventoryRequested: parseInt(noOfInventoryRequested, 10),
      };
      handleRequestEmail(requestData);
      console.log('requestData', requestData);
    }
  };

  const handleRequestEmail = async requestData => {
    setOpenLoader(true);
    const token = sessionStorage.getItem('AuthToken');
    try {
      await axios.instance
        .post(
          `SendMailForMoreAccess/${sessionStorage.getItem('Companyid')}`,
          requestData,
          {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          console.log(res.data);
          if (res.data === 'Email sent successfully') {
            setmailSentRequest(true);
            CloseReqEmailControl();
            setNoOfPoRequested('');
            setNoOfApprovalRequested('');
            setNoOfBranchRequested('');
            setNoOfInventoryRequested('');
            setOpenLoader(false);
          } else {
            setnotWorking(true);
            CloseReqEmailControl();
            setOpenLoader(false);
          }
        });
    } catch (error) {
      console.error('Failed to add email', error);
      setOpenLoader(false);
    } finally {
      setOpenLoader(false);
    }
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid={true}>
          <h6 className="titledept"> Customer Access Controls </h6>
          <Card style={{ backgroundColor: 'white', marginBottom: '10px' }}>
            <CardBody>
              <Row className="mx-2">
                <Col lg={12}>
                  <Divider>
                    <Chip
                      label="Po Access Balance"
                      size="medium"
                      color="success"
                      variant="outlined"
                    />
                  </Divider>
                </Col>
                <Col lg={3} className="my-3">
                  <Card
                    style={{
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      minHeight: '30px',
                      cursor: 'pointer',
                    }}
                    className="border-none text-white-50 card1"
                    // onClick={OpenReqEmailControl}
                  >
                    <CardBody
                      style={{
                        color: '#4b4c4d',
                        backgroundColor: 'ghostwhite',
                        padding: 0,
                        margin: '3px',
                        borderRadius: '8px',
                      }}
                    >
                      <h6
                        className="m-0 font-size-30 text-center"
                        style={{
                          fontWeight: 'bold',
                          color: 'white',
                          letterSpacing: '1px',
                          padding: '20px',
                          background:
                            '-webkit-linear-gradient(to right, #182848, #4b6cb7)',
                          background:
                            'linear-gradient(to right, #182848, #4b6cb7)',
                          borderTopLeftRadius: 11,
                          borderTopRightRadius: 11,
                        }}
                      >
                       Total  Access
                      </h6>
                      <CardText className="font-size-12 mt-2 p-0 ">
                        <div className="m-1 p-1 text-center">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '2rem',
                                color: (customerAccess) <= 0 ? 'red' : '#007C00',
                              }}
                            >
                              {/* {companyAccessData.no_of_po_acc === 'N'
                                ? 0
                                : `${companyAccessData.enable_po_count}/${companyAccessData.no_of_po_acc}`} */}
                              {format((customerAccess))}
                            </span>
                          </p>
                        </div>
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={3} className="my-3">
                  <Card
                    // onClick={OpenReqEmailControl}
                    style={{
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      minHeight: '30px',
                      cursor: 'pointer',
                    }}
                    className="border-none text-white-50 card1"
                  >
                    <CardBody
                      style={{
                        color: '#4b4c4d',
                        backgroundColor: 'ghostwhite',
                        padding: 0,
                        margin: '3px',
                        borderRadius: '8px',
                      }}
                    >
                      <h6
                        className="m-0 font-size-30 text-center"
                        style={{
                          fontWeight: 'bold',
                          color: 'white',
                          letterSpacing: '1px',
                          padding: '20px',
                          background:
                            '-webkit-linear-gradient(to right, #182848, #4b6cb7)',
                          background:
                            'linear-gradient(to right, #182848, #4b6cb7)',
                          borderTopLeftRadius: 11,
                          borderTopRightRadius: 11,
                        }}
                      >
                        Access given
                      </h6>
                      <CardText className="font-size-12 mt-2 p-0 ">
                        <div className="m-1 p-1 text-center">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '2rem',
                                color: Accessedcus <= 0 ? 'red' : '#007C00',
                              }}
                            >
                              {/* {companyAccessData.no_of_branch_acc === 'N'
                                ? 0
                                : `${companyAccessData.enable_branch_count}/${companyAccessData.no_of_branch_acc}`} */}

                              {format(Accessedcus)}
                            </span>
                          </p>
                        </div>
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={3} className="my-3">
                  <Card
                    // onClick={OpenReqEmailControl}
                    style={{
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      minHeight: '30px',
                      cursor: 'pointer',
                    }}
                    className="border-none text-white-50 card1"
                  >
                    <CardBody
                      style={{
                        color: '#4b4c4d',
                        backgroundColor: 'ghostwhite',
                        padding: 0,
                        margin: '3px',
                        borderRadius: '8px',
                      }}
                    >
                      <h6
                        className="m-0 font-size-30 text-center"
                        style={{
                          fontWeight: 'bold',
                          color: 'white',
                          letterSpacing: '1px',
                          padding: '20px',
                          background:
                            '-webkit-linear-gradient(to right, #182848, #4b6cb7)',
                          background:
                            'linear-gradient(to right, #182848, #4b6cb7)',
                          borderTopLeftRadius: 11,
                          borderTopRightRadius: 11,
                        }}
                      >
                        Pending  Access
                      </h6>
                      <CardText className="font-size-12 mt-2 p-0 ">
                        <div className="m-1 p-1 text-center">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '2rem',
                                color: customerAccess-Accessedcus <= 0 ? 'red' : '#007C00',
                              }}
                            >
                              {/* {companyAccessData.no_of_branch_acc === 'N'
                                ? 0
                                : `${companyAccessData.enable_branch_count}/${companyAccessData.no_of_branch_acc}`} */}

                              {format(customerAccess-Accessedcus)}
                            </span>
                          </p>
                        </div>
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={3} className="my-3">
                  <Card
                    // onClick={OpenReqEmailControl}
                    style={{
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      minHeight: '30px',
                      cursor: 'pointer',
                    }}
                    className="border-none text-white-50 card1"
                  >
                    <CardBody
                      style={{
                        color: '#4b4c4d',
                        backgroundColor: 'ghostwhite',
                        padding: 0,
                        margin: '3px',
                        borderRadius: '8px',
                      }}
                    >
                      <h6
                        className="m-0 font-size-30 text-center"
                        style={{
                          fontWeight: 'bold',
                          color: 'white',
                          letterSpacing: '1px',
                          padding: '20px',
                          background:
                            '-webkit-linear-gradient(to right, #182848, #4b6cb7)',
                          background:
                            'linear-gradient(to right, #182848, #4b6cb7)',
                          borderTopLeftRadius: 11,
                          borderTopRightRadius: 11,
                        }}
                      >
                        TOMPG Access
                      </h6>
                      <CardText className="font-size-12 mt-2 p-0 ">
                        <div className="m-1 p-1 text-center">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '2rem',
                                color: TompgFlag !=true ? 'red' : '#007C00',
                              }}
                            >
                              {/* {companyAccessData.no_of_approve_acc === 'N'
                                ? 0
                                : `${companyAccessData.enable_approval_count}/${companyAccessData.no_of_approve_acc}`} */}
                              {(TompgFlag ? <span style={{fontSize:'20px'}}>Active</span> : <span style={{fontSize:'20px'}}>InActive</span>)}
                            </span>
                          </p>
                        </div>
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
{/*              
                <Col lg={3} className="my-3">
                  <Card
                    onClick={OpenReqEmailControl}
                    style={{
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      minHeight: '30px',
                      cursor: 'pointer',
                    }}
                    className="border-none text-white-50 card1"
                  >
                    <CardBody
                      style={{
                        color: '#4b4c4d',
                        backgroundColor: 'ghostwhite',
                        padding: 0,
                        margin: '3px',
                        borderRadius: '8px',
                      }}
                    >
                      <h6
                        className="m-0 font-size-30 text-center"
                        style={{
                          fontWeight: 'bold',
                          color: 'white',
                          letterSpacing: '1px',
                          padding: '20px',
                          background:
                            '-webkit-linear-gradient(to right, #182848, #4b6cb7)',
                          background:
                            'linear-gradient(to right, #182848, #4b6cb7)',
                          borderTopLeftRadius: 11,
                          borderTopRightRadius: 11,
                        }}
                      >
                        Inventory
                      </h6>
                      <CardText className="font-size-12 mt-2 p-0 ">
                        <div className="m-1 p-1 text-center">
                          <p
                            style={{
                              fontWeight: '600',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '2rem',
                                color:
                                  inventoryBalance <= 0 ? 'red' : '#007C00',
                              }}
                            >                              
                              {format(inventoryBalance)}
                            </span>
                          </p>
                        </div>
                      </CardText>
                    </CardBody>
                  </Card>
                </Col> */}
                <Col lg="4">
                  <Stack
                    direction={{ sm: 'row', xs: 'column' }}
                    spacing={2}
                    justifyContent={'start'}
                    alignItems={'center'}
                    pt={1}
                  >
                    <TextField
                      variant="outlined"
                      size="small"
                      className="p-0"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                </Col>
                <Col lg="8">
                  <Stack
                    direction={{ md: 'row', xs: 'column' }}
                    spacing={2}
                    justifyContent={'end'}
                    alignItems={'center'}
                  >
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <Divider className="my-2">
                        {' '}
                        <Chip
                          label=" Controls"
                          color="success"
                          size="small"
                        />{' '}
                      </Divider>
                      <Row className="p-3 w-100 ml-1">
                        {[
                          'enable_mis',
                          'enable_po',
                          'enable_approval',
                          'enable_branch',
                          'enable_inventory',
                        ].map(filter => (
                          <Col lg="6" className="card py-2" key={filter}>
                            <Row>
                              <Col
                                lg="10"
                                className="d-flex justify-content-center align-items-center"
                              >
                                <label htmlFor={filter}>
                                  {filter
                                    .replace('enable_', '')
                                    .replace('_', ' ')
                                    .toUpperCase()}
                                </label>
                              </Col>
                              <Col
                                lg="2"
                                className="d-flex justify-content-center align-items-center"
                              >
                                <input
                                  id={filter}
                                  className="checkbox"
                                  type="checkbox"
                                  checked={selectedFilters[filter]}
                                  onChange={() => handleFilterChange(filter)}
                                />
                              </Col>
                            </Row>
                          </Col>
                        ))}
                      </Row>
                    </Popover>

                    <Button2
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={toggle10}
                    >
                      Add Customer
                    </Button2>
                    {/* Command BY Yuki  not Need  */}
                    {/* <Button2
                      variant="outlined"
                      color="secondary"
                      size="small"
                      onClick={OpenReqEmailControl}
                    >
                      Access Request
                    </Button2> */}
                    {!bulkMailMode && (
                      <Button2
                        variant="contained"
                        color="primary"
                        size="small"
                        className="btn btn-success"
                        onClick={handleBulkMailToggle}
                      >
                        Bulk Mail
                      </Button2>
                    )}

                    {/* <IconButton
                      aria-label=""
                      aria-describedby={id}
                      onClick={handleClick}
                      sx={{ border: '1px solid grey', boxShadow: 2 }}
                    >
                      <FilterAltIcon color="primary" />
                    </IconButton> */}
                  </Stack>
                </Col>
              </Row>

              <TableContainer style={{ marginTop: '20px' }}>
                <Table responsive className="table-borderless">
                  <TableBody>
                    {filteredData.length !== 0 ? (
                      changepage()
                        .filter(
                          data => !bulkMailMode || data.enable_mis === 'Y',
                        )
                        .map(data => (
                          <TableRow key={data.cusaccessid}>
                            <TableCell>
                              <Row>
                                <Col lg={bulkMailMode ? '12' : '12'}>
                                  <Paper
                                    sx={{
                                      p: 2,
                                    }}
                                    elevation={3}
                                    className="mx-0"
                                  >
                                    <Row>
                                      <Col md="10">
                                        <Row>
                                          <Col lg="12" className="my-2">
                                            <Row>
                                              <Col lg="4">
                                                <Stack
                                                  direction={{ xs: 'column' }}
                                                  justifyContent={'start'}
                                                  alignItems={'start'}
                                                >
                                                  <Typography
                                                    align="left"
                                                    variant="body2"
                                                    color="inherit"
                                                    style={{
                                                      textTransform:
                                                        'capitalize',
                                                    }}
                                                  >
                                                    Customer Name
                                                  </Typography>
                                                  <Typography
                                                    align="left"
                                                    variant="subtitle2"
                                                    color="primary"
                                                    style={{
                                                      textTransform:
                                                        'capitalize',
                                                    }}
                                                  >
                                                    {data.Customer_Name}
                                                  </Typography>
                                                </Stack>
                                              </Col>
                                              <Col lg={4}>
                                                <Stack
                                                  direction={{ xs: 'column' }}
                                                  justifyContent="start"
                                                  alignItems="start"
                                                >
                                                  <Typography
                                                    align="left"
                                                    variant="body2"
                                                    color="inherit"
                                                    style={{
                                                      textTransform:
                                                        'capitalize',
                                                    }}
                                                  >
                                                    Email:
                                                  </Typography>
                                                  <Typography
                                                    align="left"
                                                    variant="subtitle2"
                                                    color={isAvailable(data.customer_id, data.EmailId) ? "primary" : "error"}
                                                    style={{
                                                      textTransform:
                                                        'lowercase',
                                                    }}
                                                  >
                                                    {validateEmail(
                                                      data.EmailId
                                                    ) ? (
                                                      data.EmailId
                                                    ) : (

                                                      // <a
                                                      //   href="#"
                                                      //   onClick={e => {
                                                      //     e.preventDefault();
                                                      //     OpenAddEmailControl();
                                                      //     setCustomerID(
                                                      //       data.customer_id,
                                                      //     );
                                                      //   }}
                                                      //   style={{
                                                      //     color: 'inherit',
                                                      //     textDecoration:
                                                      //       'none',
                                                      //   }}
                                                      //   className="btn btn-sm  text-danger btn-outline-danger"
                                                      // >
                                                      //   add missing email
                                                      // </a>
                                                      ''
                                                    )}
                                                  </Typography>
                                                </Stack>
                                              </Col>

                                              {data.last_mailed_on !==
                                                'Jan  1 1900 12:00AM' && (
                                                  <Col lg="4">
                                                    <Stack
                                                      direction={{ xs: 'column' }}
                                                      justifyContent={'start'}
                                                      alignItems={'start'}
                                                    >
                                                      <Typography
                                                        align="left"
                                                        variant="body2"
                                                        color="inherit"
                                                        style={{
                                                          textTransform:
                                                            'capitalize',
                                                        }}
                                                      >
                                                        Last Mailed on
                                                      </Typography>
                                                      <Typography
                                                        align="left"
                                                        variant="subtitle2"
                                                        color="primary"
                                                        style={{
                                                          textTransform:
                                                            'capitalize',
                                                        }}
                                                      >
                                                        {data.last_mailed_on}
                                                      </Typography>
                                                    </Stack>
                                                  </Col>
                                                )}
                                            </Row>
                                          </Col>
                                          {data.enable_mis === 'Y' &&
                                            !bulkMailMode && (
                                              <Col lg="12" className="my-2">
                                                <Stack
                                                  direction={{ xs: 'row' }}
                                                  spacing={2}
                                                  justifyContent={'start'}
                                                  alignItems={'center'}
                                                >
                                                  <Typography
                                                    align="left"
                                                    variant="caption"
                                                    color="inherit"
                                                    fullWidth
                                                  >
                                                    Controls
                                                  </Typography>
                                                </Stack>

                                                <Stack
                                                  direction={{ xs: 'row' }}
                                                  spacing={2}
                                                  justifyContent={'start'}
                                                  alignItems={'center'}
                                                  flexWrap={'wrap'}
                                                >
                                                  {data.enable_mis === 'Y' && (
                                                    <Chip
                                                      label={'reports'}
                                                      size="small"
                                                      color="info"
                                                      variant="filled"
                                                    />
                                                  )}
                                                  {data.enable_branch ===
                                                    'Y' && (
                                                      <Chip
                                                        label={'branch'}
                                                        size="small"
                                                        color="info"
                                                        variant="filled"
                                                      />
                                                    )}
                                                  {data.enable_inventory ===
                                                    'Y' && (
                                                      <Chip
                                                        label={'inventory'}
                                                        size="small"
                                                        color="info"
                                                        variant="filled"
                                                      />
                                                    )}
                                                  {data.enable_po === 'Y' && (
                                                    <Chip
                                                      label={'create po'}
                                                      size="small"
                                                      color="info"
                                                      variant="filled"
                                                    />
                                                  )}
                                                  {data.enable_approval ===
                                                    'Y' && (
                                                      <Chip
                                                        label={'po approval'}
                                                        size="small"
                                                        color="info"
                                                        variant="filled"
                                                      />
                                                    )}
                                                </Stack>
                                              </Col>
                                            )}
                                        </Row>
                                      </Col>
                                      <Col md="2">
                                        {!bulkMailMode && (
                                          <Stack
                                            direction={{ xs: 'column' }}
                                            spacing={2}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                          >
                                            {/* comment By Yuki 23-04-2025 */}
                                            {/* <Button
                                              color="primary"
                                              outline
                                              size="sm"
                                              className="w-100"
                                              onClick={() => {
                                                GetOneCustomerAccess(
                                                  data.cusaccessid,
                                                );
                                              }}
                                              startIcon={<TuneIcon />}
                                            >
                                              Controls
                                            </Button> */}
                                            <Button
                                              color="warning"
                                              outline
                                              size="sm"
                                              className="w-100"
                                              onClick={e => {
                                                e.preventDefault();
                                                setNewEmail(data.EmailId);
                                                OpenAddEmailControl();
                                                setCustomerID(
                                                  data.customer_id,
                                                );
                                              }}

                                            >
                                              Update Mail Id
                                            </Button>

                                            {data.enable_mis === 'Y' &&
                                              validateEmail(data.EmailId) && (
                                                <Button
                                                  color="success"
                                                  outline
                                                  size="sm"
                                                  className="w-100"
                                                  onClick={() =>
                                                    handleSendMail(
                                                      data.customer_id,
                                                      data.EmailId,
                                                    )
                                                  }
                                                  startIcon={
                                                    <ForwardToInboxIcon />
                                                  }
                                                >
                                                  Send Mail
                                                </Button>
                                              )}
                                            <Button
                                              color="danger"
                                              outline
                                              size="sm"
                                              className="w-100"
                                              onClick={() => {
                                                setdeletedconfirm(true);
                                                setdeleteid(data.customer_id);
                                              }}
                                              startIcon={<DeleteIcon />}
                                            >
                                              Delete
                                            </Button>
                                          </Stack>
                                        )}
                                        {bulkMailMode &&
                                          data.enable_mis === 'Y' &&
                                          validateEmail(data.EmailId) && (
                                            <Stack
                                              direction={'column'}
                                              anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                              }}
                                              transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                              }}
                                              justifyContent={'center'}
                                              alignItems={'center'}
                                            >
                                              <Typography
                                                variant="button"
                                                color="initial"
                                              >
                                                Select
                                              </Typography>
                                              <input
                                                id={`Controls`}
                                                className="checkbox"
                                                type="checkbox"
                                                checked={selectedCustomers.includes(
                                                  data.customer_id,
                                                )}
                                                onChange={event =>
                                                  handleCustomerCheckboxChange(
                                                    data.customer_id,
                                                    event.target.checked,
                                                  )
                                                }
                                              />
                                            </Stack>
                                          )}
                                      </Col>
                                    </Row>
                                  </Paper>
                                </Col>
                              </Row>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableCell align="left">
                        {' '}
                        <Stack
                          direction="column"
                          spacing={2}
                          justifyContent={'center'}
                          alignItems={'center'}
                        >
                          <img
                            alt="no data"
                            src={logoqa}
                            style={{ objectFit: 'contain', maxWidth: '300px' }}
                          />
                          <Typography variant="subtitle2" color="secondary">
                            sorry! no results found
                          </Typography>
                        </Stack>
                      </TableCell>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                rowsPerPageOptions={pages}
                count={tabledata.length}
                rowsPerPage={rowsperpage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
              {bulkMailMode && (
                <Stack
                  direction={{ sm: 'row', xs: 'column' }}
                  spacing={2}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <Button
                    variant="contained"
                    color="default"
                    size="small"
                    onClick={handleBulkMailToggle}
                    className="btn btn-warning"
                  >
                    Cancel Bulk Mail
                  </Button>
                  {selectedCustomers.length > 0 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      className="btn btn-success"
                      onClick={handleSendBulkMail}
                    >
                      Send Bulk Mail
                    </Button>
                  )}
                </Stack>
              )}
            </CardBody>
          </Card>
        </Container>

        {/* Select Cutsomers */}
        <Modal isOpen={modal10} toggle={toggle10} size="xl">
          {customersData.length > 0 && (
            <ModalHeader
              toggle={() => {
                setsearchval(false);
                setInputValue('');
                toggle10();
              }}
              tag={'h4'}
            >
              <div className="d-flex">
                <Typography variant="h6" color="#3652AD" sx={{ pr: 2 }}>
                  Select Customer
                </Typography>
              </div>
            </ModalHeader>
          )}
          <ModalBody>
            {customersData.length > 0 ? (
              <>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', my: 2 }}>
                  <ContentPasteSearchIcon
                    sx={{ color: 'action.active', mr: 1, my: 0.5 }}
                  />
                  <TextField
                    id="input-with-sx"
                    label="Search Customers"
                    variant="standard"
                    fullWidth
                    value={InputValue}
                    onChange={handleChange3}
                  />
                </Box>
                <TableContainer2 component={Paper} sx={{ maxHeight: 500 }}>
                  <Table2 stickyHeader aria-label="sticky table">
                    <TableHead2>
                      <TableRow2>
                        <TableCell2
                          align="center"
                          style={{ backgroundColor: '#7ABA78', color: 'white' }}
                        >
                          Customer Details
                        </TableCell2>
                        <TableCell2
                          align="center"
                          style={{ backgroundColor: '#7ABA78', color: 'white' }}
                        >
                          Action
                        </TableCell2>
                      </TableRow2>
                    </TableHead2>
                    <TableBody2>
                      {(searchval ? filteredAccess : customersData).map(
                        (data, index) => (
                          <TableRow2
                            key={index}
                            hover
                            style={{ cursor: 'pointer' }}
                          >
                            <TableCell2>
                              <Row>
                                <Col lg="12" className="mb-3">
                                  <Stack
                                    direction={{ xs: 'column' }}
                                    justifyContent={'start'}
                                    alignItems={'start'}
                                  >
                                    <Typography
                                      align="left"
                                      variant="body2"
                                      color="inherit"
                                      style={{
                                        textTransform: 'capitalize',
                                      }}
                                    >
                                      Company Name
                                    </Typography>
                                    <Typography
                                      align="left"
                                      variant="subtitle2"
                                      color="primary"
                                      style={{
                                        textTransform: 'capitalize',
                                      }}
                                    >
                                      {data.Customer_Name}
                                    </Typography>
                                  </Stack>
                                </Col>{' '}
                                <Col lg="6">
                                  {' '}
                                  <Stack
                                    direction={{ xs: 'column' }}
                                    justifyContent={'start'}
                                    alignItems={'start'}
                                  >
                                    <Typography
                                      align="left"
                                      variant="body2"
                                      color="inherit"
                                      style={{
                                        textTransform: 'capitalize',
                                      }}
                                    >
                                      Contact Person
                                    </Typography>
                                    <Typography
                                      align="left"
                                      variant="subtitle2"
                                      color="primary"
                                      style={{
                                        textTransform: 'capitalize',
                                      }}
                                    >
                                      {data.Contact_Person}
                                    </Typography>
                                  </Stack>
                                </Col>
                                <Col lg="6">
                                  {' '}
                                  <Stack
                                    direction={{ xs: 'column' }}
                                    justifyContent={'start'}
                                    alignItems={'start'}
                                  >
                                    <Typography
                                      align="left"
                                      variant="body2"
                                      color="inherit"
                                      style={{
                                        textTransform: 'capitalize',
                                      }}
                                    >
                                      Email
                                    </Typography>
                                    <Typography
                                      align="left"
                                      variant="subtitle2"
                                      color="primary"
                                      style={{
                                        textTransform: 'lowercase',
                                      }}
                                    >
                                      {data.EmailId}
                                    </Typography>
                                  </Stack>
                                </Col>
                              </Row>
                            </TableCell2>

                            <TableCell2 align="center">
                              <input
                                id={`Controls`}
                                className="checkbox"
                                type="checkbox"
                                checked={!!selectedCustomers1[data.Customer_Id]}
                                onChange={() =>
                                  handleCheckboxChange1(data.Customer_Id, data.companyaccessid)
                                }
                              />
                            </TableCell2>
                          </TableRow2>
                        ),
                      )}
                    </TableBody2>
                  </Table2>
                </TableContainer2>
              </>
            ) : (
              <>
                <Stack
                  direction="column"
                  spacing={2}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <img
                    alt="no data"
                    src={logoqa}
                    style={{ objectFit: 'contain', maxWidth: '300px' }}
                  />
                  <Typography variant="subtitle2" color="secondary">
                    Sorry! no more customers to add
                  </Typography>
                </Stack>
              </>
            )}
          </ModalBody>
          {customersData.length > 0 && (
            <ModalFooter style={{ justifyContent: 'center' }}>
              {selectedCustomerIds.length > 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  className="btn btn-success"
                  onClick={() => {
                    if(customerAccess-Accessedcus == 0){
                      toastr.warning("You have reached the maximum limit of customer access. Please contact admin to increase the limit.");
                    }else{
                      handleInsertSelectedCustomers();
                     
                    }
                   
                  }}
                >
                  Add selected
                </Button>
              )}
            </ModalFooter>
          )}
        </Modal>

        <Dialog open={openControls} onClose={CloseDialogControls} maxWidth="sm">
          <DialogTitle>{`${editCustomersAccessData.Customer_Name} -  Controls`}</DialogTitle>
          <Divider className="my-2" />
          <DialogContent>
            <Row>
              {/* <Col lg="12">
                <Row>
                  <Col lg="10">
                    <label htmlFor="Controls">Reports</label>
                  </Col>
                  <Col lg="2">
                    <input
                      id={`Controls`}
                      className="checkbox"
                      type="checkbox"
                      checked={customerAccData.enable_mis}
                      onChange={() => {
                        handleCheckboxChange('enable_mis');
                        console.log(customerAccData.enable_mis, 'enable mis');
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg="12">
                <Divider className="my-2 mb-3" />
                <Row>
                  <Col lg="10">
                    <label htmlFor="Controls">Create PO</label>
                    <br />
                    {createBalance <= 0 &&
                      !customerAccessDataTemp.enable_po && (
                        <span
                          className="text-danger text-style22 font-weight-light cursor"
                          style={{ fontSize: 'medium', cursor: 'pointer' }}
                        >
                          maximum limit reached!{' '}
                          <span
                            className="text-primary"
                            onClick={OpenReqEmailControl}
                            style={{ color: 'black' }}
                          >
                            request more
                          </span>
                        </span>
                      )}
                  </Col>

                  <Col lg="2">
                    <input
                      id="Controls"
                      disabled={
                        customerAccData.enable_mis === false
                          ? true
                          : customerAccessDataTemp.enable_po
                            ? false
                            : createBalance <= 0 ||
                            customerAccData.enable_mis === false
                      }
                      className={
                        (
                          customerAccData.enable_mis === false
                            ? true
                            : customerAccessDataTemp.enable_po
                              ? false
                              : createBalance <= 0 ||
                              customerAccData.enable_mis === false
                        )
                          ? 'checkbox_disabled'
                          : 'checkbox'
                      }
                      type="checkbox"
                      checked={customerAccData.enable_po}
                      onChange={() => {
                        handleCheckboxChange('enable_po');
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg="12">
                <Divider className="my-2 mb-3" />
                <Row>
                  <Col lg="10">
                    <label htmlFor="Controls">Approval</label>
                    <br />
                    {ApprovalBalance <= 0 &&
                      !customerAccessDataTemp.enable_approval && (
                        <span
                          className="text-danger text-style22 font-weight-light cursor"
                          style={{ fontSize: 'medium', cursor: 'pointer' }}
                        >
                          maximum limit reached!{' '}
                          <span
                            className="text-primary"
                            onClick={OpenReqEmailControl}
                            style={{ color: 'black' }}
                          >
                            request more
                          </span>
                        </span>
                      )}
                  </Col>

                  <Col lg="2">
                    <input
                      id="Controls"
                      disabled={
                        customerAccData.enable_po === false
                          ? true
                          : customerAccessDataTemp.enable_approval
                            ? false
                            : ApprovalBalance <= 0 ||
                            customerAccData.enable_po === false
                      }
                      className={
                        (
                          customerAccData.enable_po === false
                            ? true
                            : customerAccessDataTemp.enable_approval
                              ? false
                              : ApprovalBalance <= 0 ||
                              customerAccData.enable_po === false
                        )
                          ? 'checkbox_disabled'
                          : 'checkbox'
                      }
                      type="checkbox"
                      checked={customerAccData.enable_approval}
                      onChange={() => {
                        handleCheckboxChange('enable_approval');
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg="12">
                <Divider className="my-2 mb-3" />
                <Row>
                  <Col lg="10">
                    <label htmlFor="Controls">Branches</label>
                    <br />
                    {branchbalance <= 0 &&
                      !customerAccessDataTemp.enable_branch && (
                        <span
                          className="text-danger text-style22 font-weight-light cursor"
                          style={{ fontSize: 'medium', cursor: 'pointer' }}
                        >
                          maximum limit reached!{' '}
                          <span
                            className="text-primary"
                            onClick={OpenReqEmailControl}
                            style={{ color: 'black' }}
                          >
                            request more
                          </span>
                        </span>
                      )}
                  </Col>

                  <Col lg="2">
                    <input
                      id="Controls"
                      disabled={
                        customerAccData.enable_approval === false
                          ? true
                          : customerAccessDataTemp.enable_branch
                            ? false
                            : branchbalance <= 0 ||
                            customerAccData.enable_approval === false
                      }
                      className={
                        (
                          customerAccData.enable_approval === false
                            ? true
                            : customerAccessDataTemp.enable_branch
                              ? false
                              : branchbalance <= 0 ||
                              customerAccData.enable_approval === false
                        )
                          ? 'checkbox_disabled'
                          : 'checkbox'
                      }
                      type="checkbox"
                      checked={customerAccData.enable_branch}
                      onChange={() => handleCheckboxChange('enable_branch')}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg="12">
                <Divider className="my-2 mb-3" />
                <Row>
                  <Col lg="10">
                    <label htmlFor="Controls">Inventory</label>
                    <br />
                    {inventoryBalance <= 0 &&
                      !customerAccessDataTemp.enable_inventory && (
                        <span
                          className="text-danger text-style22 font-weight-light cursor"
                          style={{ fontSize: 'medium', cursor: 'pointer' }}
                        >
                          maximum limit reached!{' '}
                          <span
                            className="text-primary"
                            onClick={OpenReqEmailControl}
                            style={{ color: 'black' }}
                          >
                            request more
                          </span>
                        </span>
                      )}
                  </Col>
                  <Col lg="2">
                    <input
                      id="Controls"
                      disabled={
                        customerAccData.enable_mis === false
                          ? true
                          : customerAccessDataTemp.enable_inventory
                            ? false
                            : inventoryBalance <= 0 ||
                            customerAccData.enable_mis === false
                      }
                      className={
                        (
                          customerAccData.enable_mis === false
                            ? true
                            : customerAccessDataTemp.enable_inventory
                              ? false
                              : inventoryBalance <= 0 ||
                              customerAccData.enable_mis === false
                        )
                          ? 'checkbox_disabled'
                          : 'checkbox'
                      }
                      type="checkbox"
                      checked={customerAccData.enable_inventory}
                      onChange={() => handleCheckboxChange('enable_inventory')}
                    />
                  </Col>
                </Row>
              </Col> */}
              <Col lg="12">
                <Divider className="my-2 mb-3" />
                <Row>
                  <Col lg="10">
                    <label htmlFor="Controls">Toms Access</label>
                  </Col>
                  <Col lg="2">
                    <input
                      id={`Controls`}
                      className="checkbox"
                      disabled={customerAccData.imageAccess}
                      type="checkbox"
                      checked={customerAccData.tomsWinAccess}
                      onChange={() => {
                        handleCheckboxChange('tomsWinAccess');
                        console.log(customerAccData.tomsWinAccess, 'tomsWinAccess');
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              {/* Image Access */}
              <Col lg="12">
                <Divider className="my-2 mb-3" />
                <Row>
                  <Col lg="10">
                    <label htmlFor="Controls">Image Access</label>
                  </Col>
                  <Col lg="2">
                    <input
                      id={`Controls`}
                      className="checkbox"
                      disabled={customerAccData.tomsWinAccess}
                      type="checkbox"
                      checked={customerAccData.imageAccess}
                      onChange={() => {
                        handleCheckboxChange('imageAccess');
                        console.log(customerAccData.imageAccess, 'imageAccess');
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg="12">
                <Divider className="my-2" />
                <Stack
                  spacing={2}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={CustomerAccessUpdate}
                  >
                    Save
                  </Button>
                </Stack>
              </Col>
            </Row>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openAddEmail}
          onClose={CloseAddEmailControl}
          maxWidth="lg"
        >
          <DialogTitle>Update Email</DialogTitle>

          <DialogContent
            style={{ minWidth: matchesSmallScreen ? '90vw' : '50vw' }}
          >
            <FormGroup className="w-100">
              <Label for="email">Enter Email:</Label>
              <Input
                type="email"
                id="email"
                value={newEmail}
                onChange={e => setNewEmail(e.target.value)}
              />
              {emailHelperText && <p className="errors">{emailHelperText}</p>}
            </FormGroup>
            <Stack
              spacing={2}
              justifyContent={'center'}
              alignItems={'center'}
              className="my-2"
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={handleAddEmail}
                disabled={openLoader}
              >
                Save
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openRequestEmail}
          onClose={CloseReqEmailControl}
          maxWidth="lg"
        >
          <DialogTitle>
            <span>Request for More Access Controls</span>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <FormGroup className="w-100">
              <Label for="noOfPoRequested" className="text-primary">
                No of PO Access
              </Label>
              <Input
                type="number"
                id="noOfPoRequested"
                value={noOfPoRequested}
                onChange={e => setNoOfPoRequested(e.target.value)}
              />
            </FormGroup>
            <FormGroup className="w-100">
              <Label for="noOfApprovalRequested" className="text-primary">
                No of Approval Access
              </Label>
              <Input
                type="number"
                id="noOfApprovalRequested"
                value={noOfApprovalRequested}
                onChange={e => setNoOfApprovalRequested(e.target.value)}
              />
            </FormGroup>
            <FormGroup className="w-100">
              <Label for="noOfBranchRequested" className="text-primary">
                No of Branch Access
              </Label>
              <Input
                type="number"
                id="noOfBranchRequested"
                value={noOfBranchRequested}
                onChange={e => setNoOfBranchRequested(e.target.value)}
              />
            </FormGroup>
            <FormGroup className="w-100">
              <Label for="noOfInventoryRequested" className="text-primary">
                No of Inventory Access
              </Label>
              <Input
                type="number"
                id="noOfInventoryRequested"
                value={noOfInventoryRequested}
                onChange={e => setNoOfInventoryRequested(e.target.value)}
              />
            </FormGroup>
            {error && <span className="errors">{error}</span>}
            <Stack
              spacing={2}
              justifyContent={'center'}
              alignItems={'center'}
              className="my-2"
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={handleRequest}
                disabled={openLoader}
              >
                Request
              </Button>
            </Stack>
            <Divider className="mb-2" />
            <span
              className="text-mute mt-2 text-wrap text-center text-style22 font-weight-light cursor"
              style={{ fontSize: 'small', cursor: 'pointer' }}
            >
              Note: By submitting the above request, Ask Technology will receive
              your request and promptly contact you to discuss further.
            </span>
          </DialogContent>
        </Dialog>

        {/* loader popup dialog box */}
        <Dialog
          open={openLoader}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <LinearProgress />
        </Dialog>

        {added ? (
          <SweetAlert
            title=" Added Successfully"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setadded(false);
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}
        {deleted ? (
          <SweetAlert
            title=" Customer Access Deleted Successfully"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setdeleted(false);
              GetALLCustomerList();
              GetAllCustomerAccess();
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}
        {duplicateerror ? (
          <SweetAlert
            title="Department Name Already Exists"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setduplicateerror(false);
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}

        {deletedconfirm ? (
          <SweetAlert
            title="Are You Sure?"
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            confirmBtnBsStyle="success"
            showConfirm={true}
            cancelBtnBsStyle="danger"
            cancelBtnText="Cancel"
            confirmBtnText="Yes,delete it!"
            showCancel={true}
            warning
            onConfirm={() => {
              CustomerAccessDelete(deleteid);
              setdeletedconfirm(false);
            }}
            onCancel={() => {
              setdeletedconfirm(false);
              setdeleted(false);
            }}
          >
            <p style={{ fontSize: '20px' }}>
              Deleting this customer access will also deactivate users created
              under this customer.
            </p>
            <p style={{ fontSize: '16px', marginTop: '10px' }}>
              Are you sure you want to proceed?
            </p>
          </SweetAlert>
        ) : null}
        {updated ? (
          <SweetAlert
            title="Customer Access Updated Successfully"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setupdated(false);
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}
        {mailSent ? (
          <SweetAlert
            title={` Credentials has been Sent Successfully in Email`}
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setMailSent(false);
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}
        {mailSentRequest ? (
          <SweetAlert
            title="Your Request has been Received Successfully. Our Team will Contact You Shortly."
            timeout={3000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setmailSentRequest(false);
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}
        {notWorking ? (
          <SweetAlert
            title=" Unable To Process"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            error
            onConfirm={() => {
              setnotWorking(false);
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}
        {emailErr ? (
          <SweetAlert
            title=" Can't Proceed, Invalid Email Address"
            timeout={3000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            error
            onConfirm={() => {
              setEmailErr(false);
            }}
          >
            {' '}
          </SweetAlert>
        ) : null}
      </div>
    </React.Fragment>
  );
}

export default CustomerAccessControls;
